import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const GreatGarden = {
  id: "53",
  name: "Great Garden",
  width: 6,
  height: 4,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Great_Garden",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Great_Garden',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          25, 25, 48, 48, 66, 66, 80, 80, 80, 100, 100, 111, 111, 122, 122, 122,
          137, 137, 146, 146, 155, 155, 164, 164, 172, 172, 181, 181, 189, 189,
          196, 196, 196, 207, 207, 215, 215, 222, 225, 229, 232, 236, 239, 243,
          246, 250, 253, 257, 260, 264, 267, 271, 274, 278, 281, 285, 288, 292,
          295, 299,
        ],
        bronzeAge: [
          30, 30, 58, 58, 79, 79, 96, 96, 96, 119, 119, 133, 133, 146, 146, 146,
          164, 164, 176, 176, 186, 186, 197, 197, 207, 207, 217, 217, 226, 226,
          235, 235, 235, 249, 249, 258, 258, 266, 270, 274, 278, 282, 286, 290,
          294, 298, 302, 306, 310, 314, 318, 322, 326, 330, 334, 338, 342, 346,
          350, 354,
        ],
        minoanEra: [
          35, 35, 68, 68, 92, 92, 112, 112, 112, 139, 139, 155, 155, 171, 171,
          171, 192, 192, 205, 205, 217, 217, 230, 230, 241, 241, 253, 253, 264,
          264, 275, 275, 275, 290, 290, 301, 301, 310, 314, 319, 323, 328, 332,
          337, 341, 346, 350, 355, 359, 364, 368, 373, 377, 382, 386, 391, 395,
          400, 404, 409,
        ],
        classicGreece: [
          40, 40, 77, 77, 105, 105, 129, 129, 129, 159, 159, 178, 178, 195, 195,
          195, 219, 219, 234, 234, 249, 249, 262, 262, 276, 276, 289, 289, 302,
          302, 314, 314, 314, 332, 332, 343, 343, 355, 361, 367, 373, 379, 385,
          391, 397, 403, 409, 415, 421, 427, 433, 439, 445, 451, 457, 463, 469,
          475, 481, 487,
        ],
        earlyRome: [
          45, 45, 87, 87, 118, 118, 145, 145, 145, 179, 179, 200, 200, 219, 219,
          219, 246, 246, 263, 263, 280, 280, 295, 295, 310, 310, 325, 325, 339,
          339, 353, 353, 353, 373, 373, 386, 386, 399, 405, 412, 418, 425, 431,
          438, 444, 451, 457, 464, 470, 477, 483, 490, 496, 503, 509, 516, 522,
          529, 535, 542,
        ],
        romanEmpire: [
          50, 50, 97, 97, 131, 131, 161, 161, 161, 199, 199, 222, 222, 244, 244,
          244, 274, 274, 293, 293, 311, 311, 328, 328, 345, 345, 361, 361, 377,
          377, 392, 392, 392, 415, 415, 429, 429, 443, 450, 457, 464, 471, 478,
          485, 492, 499, 506, 513, 520, 527, 534, 541, 548, 555, 562, 569, 576,
          583, 590, 597,
        ],
        byzantineEra: [
          55, 55, 106, 106, 144, 144, 177, 177, 177, 219, 219, 244, 244, 268, 268,
          268, 301, 301, 322, 322, 342, 342, 361, 361, 379, 379, 397, 397, 415,
          415, 432, 432, 432, 456, 456, 472, 472, 488, 496, 504, 512, 520, 528,
          536, 544, 552, 560, 568, 576, 584, 592, 600, 608, 616, 624, 632, 640,
          648, 656, 664,
        ],
        ageOfTheFranks: [
          60, 60, 116, 116, 158, 158, 193, 193, 193, 239, 239, 266, 266, 292, 292,
          292, 328, 328, 351, 351, 373, 373, 394, 394, 414, 414, 433, 433, 452,
          452, 471, 471, 471, 498, 498, 515, 515, 532, 540, 549, 557, 566, 574,
          583, 591, 600, 608, 617, 625, 634, 642, 651, 659, 668, 676, 685, 693,
          702, 710, 719,
        ],
        feudalAge: [
          65, 65, 126, 126, 171, 171, 209, 209, 209, 259, 259, 289, 289, 317, 317,
          317, 356, 356, 380, 380, 404, 404, 427, 427, 448, 448, 470, 470, 490,
          490, 510, 510, 510, 539, 539, 558, 558, 576, 585, 594, 603, 612, 621,
          630, 639, 648, 657, 666, 675, 684, 693, 702, 711, 720, 729, 738, 747,
          756, 765, 774,
        ],
        iberianEra: [
          70, 70, 135, 135, 184, 184, 225, 225, 225, 279, 279, 311, 311, 341, 341,
          341, 383, 383, 410, 410, 435, 435, 459, 459, 483, 483, 506, 506, 528,
          528, 549, 549, 549, 581, 581, 601, 601, 621, 631, 641, 651, 661, 671,
          681, 691, 701, 711, 721, 731, 741, 751, 761, 771, 781, 791, 801, 811,
          821, 831, 841,
        ],
        kingdomOfSicily: [
          77, 77, 149, 149, 202, 202, 248, 248, 248, 307, 307, 342, 342, 375, 375,
          375, 421, 421, 451, 451, 479, 479, 505, 505, 531, 531, 557, 557, 581,
          581, 604, 604, 604, 639, 639, 661, 661, 683, 694, 705, 716, 727, 738,
          749, 760, 771, 782, 793, 804, 815, 826, 837, 848, 859, 870, 881, 892,
          903, 914, 925,
        ],
        highMiddleAges: [
          85, 85, 164, 164, 222, 222, 273, 273, 273, 338, 338, 376, 376, 413, 413,
          413, 463, 463, 496, 496, 527, 527, 556, 556, 584, 584, 613, 613, 639,
          639, 664, 664, 664, 703, 703, 727, 727, 751, 756, 768, 780, 792, 804,
          816, 828, 840, 852, 864, 876, 888, 900, 912, 924, 936, 948, 960, 972,
          984, 996, 1008,
        ],
        earlyGothicEra: [
          87, 87, 169, 169, 230, 230, 285, 285, 285, 354, 354, 396, 396, 436, 436,
          436, 491, 491, 527, 527, 561, 561, 593, 593, 624, 624, 657, 657, 686,
          686, 714, 714, 714, 258, 758, 785, 785, 812, 827, 840, 853, 866, 879,
          892, 905, 918, 931, 944, 957, 970, 983, 996, 1009, 1022, 1035, 1048,
          1061, 1074, 1087, 1100,
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
        ],
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
      ]),
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3,
        3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6,
        6, 6, 6, 6, 6, 7, 7, 7, 7, 7,
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        0, 1.05, 1.05, 1.15, 1.15, 1.3, 1.3, 1.3, 1.45, 1.45,
        1.7, 1.7, 1.95, 1.95, 2.15, 2.15, 2.15, 2.25, 2.25, 2.6,
        2.6, 2.7, 2.7, 2.7, 2.7, 2.8, 2.8, 2.95, 2.95, 3.2,
        3.2, 3.2, 3.45, 3.45, 3.8, 3.8, 3.95, 3.95, 4.35, 4,
        4, 5, 5, 5, 5, 5, 5, 6, 6, 6,
        6, 6, 6, 7, 7, 7, 7, 7, 7, 8,
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
  ]),
};

export default GreatGarden;
